export function extractTempKeysFromHtml(html: string): string[] {
  const tempKeys: string[] = [];
  const marker = "#tempKey=";
  const imgSrcRegex = new RegExp(`${marker}[^"'\\s]+`, "g");
  let match;
  while ((match = imgSrcRegex.exec(html)) !== null) {
    tempKeys.push(match[0].slice(marker.length));
  }
  return tempKeys;
}

export function replaceBase64WithTempKeys(html: string, urlFormatter: (tempKey: string) => string): string {
  return html.replace(
    /src="data:[^"]*#tempKey=([^"]+)"/g,
    (_, tempKey) => `src="${urlFormatter(tempKey)}"`,
  );
}

/** True when the editor's HTML carries no visible text — an empty tiptap doc is still `<p></p>`. */
export function isHtmlEmpty(html: string): boolean {
  const dom = new DOMParser().parseFromString(html || "", "text/html");
  return (dom.documentElement.textContent || "").trim() === "";
}
